<template>
    <div class="event-list">
        <event-list-cmp></event-list-cmp>
    </div>
</template>

<script>
export default {
    name: 'event-list',
    components: {
        EventListCmp: () => import(/*webpackChunkName: "event-list" */ "@/components/EventList")
    }
}
</script>

<style lang="scss">

</style>